export function getSpectrum(state, value) {
    const activeSpectrum = state.view.spectra.activeSpectra[state.view.spectra.activeTab];
    if (value === undefined && activeSpectrum?.id) {
        const index = activeSpectrum.index;
        return state.data[index];
    }
    if (typeof value === 'number') {
        return state.data[value] || undefined;
    }
    if (typeof value === 'string') {
        return state.data.find((spectrum) => spectrum.id === value);
    }
}
